import {
  INBOUND_SUBCONTAINER_UNIT_KIND_TILE_KINDS,
  inboundArrivalUnitKindTileLabel,
  type InboundArrivalUnitKind,
} from "./inboundArrivalUnitKind";
import { cn } from "@/lib/utils";

export function InboundSubcontainerUnitKindTiles({
  value,
  onChange,
  disabled,
}: {
  value: InboundArrivalUnitKind | null;
  onChange: (kind: InboundArrivalUnitKind) => void;
  disabled?: boolean;
}): JSX.Element {
  return (
    <div
      className="grid grid-cols-4 gap-2 min-[900px]:grid-cols-8"
      role="radiogroup"
      aria-label="Container type"
    >
      {INBOUND_SUBCONTAINER_UNIT_KIND_TILE_KINDS.map((kind) => {
        const selected = value === kind;
        return (
          <button
            key={kind}
            type="button"
            role="radio"
            aria-checked={selected}
            disabled={disabled}
            onClick={() => onChange(kind)}
            className={cn(
              "min-h-11 rounded-lg border-2 px-2 py-2 text-sm font-semibold touch-manipulation",
              "focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500",
              selected
                ? "border-brand-500 bg-brand-50 text-brand-800"
                : "border-slate-200 bg-white text-slate-800 hover:border-brand-300 hover:bg-slate-50",
              disabled && "cursor-not-allowed opacity-60",
            )}
          >
            {inboundArrivalUnitKindTileLabel(kind)}
          </button>
        );
      })}
    </div>
  );
}
